import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { LocalStorageService } from '../services/local-storage/local-storage.service';

@Directive({ selector: '[kienePermission]' })
export class KienePermissionDirective implements OnInit, OnDestroy {
    private permissionIds: number[] = [];
    private sessionSub?: Subscription;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private localStorageService: LocalStorageService,
    ) {}

    ngOnInit(): void {
        this.sessionSub = this.localStorageService.watchCurrentUser().subscribe(() => this.updateView());
    }

    ngOnDestroy(): void {
        this.sessionSub?.unsubscribe();
    }

    @Input('kienePermission')
    set permissionIdsInput(ids: number[]) {
        this.permissionIds = ids;
        this.updateView();
    }

    private updateView(): void {
        this.viewContainer.clear();
        if (
            Array.isArray(this.permissionIds) &&
            this.permissionIds.length > 0 &&
            this.localStorageService.currentUserHasPermissions(this.permissionIds)
        ) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }
}
